import { useMutation, useQueryClient } from "@tanstack/react-query";
import { salveazaTargetareContact } from "@/api/endpoints/targetareContacte";
import { queryKeys } from "@/lib/queryClient";

export function useSalveazaTargetareContact() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: salveazaTargetareContact,
    onSuccess: (_, variabile) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.firma(variabile.cui),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.targetare.contacteStats(),
      });
    },
  });
}
